import { UpdateUrl } from "modules/PsyCatalog/common/services/updateUrl"
import { CurrentQuery } from "modules/PsyCatalog/common/services/currentQuery"
import { CurrentFilter } from "modules/PsyCatalog/common/services/currentFilter"
import { FieldStatus } from "modules/PsyCatalog/common/services/FieldStatus"

export const services = { UpdateUrl, CurrentQuery, CurrentFilter, FieldStatus }
export type Services = typeof services
